export const UPLOAD_TABS_ALL = 'all';
export const UPLOAD_TABS_CURRENT = 'current';
export const UPDATE_TYPE_UPDATE = 'update';
export const UPDATE_TYPE_REPLACE = 'replace';

export const SUBSCHEMACODE_BATTERY = 'PSBATSTO';
export const SUBSCHEMACODE_THERMAL = 'PSGENASSED';
